import React from 'react'
import { Container, Row } from 'react-bootstrap'

import './content.scss'

const Content = props => {
  return (<Container>
    <Row>
      {props.children}
    </Row>
  </Container>);
}

Content.propTypes = {}

export default Content
